import { PureComponent, ReactNode } from 'react';
import { GLabVitalEntity } from '../../store/db';
import { LOCAL_ID_PREFIX } from '../../constants';
import PadV2AutoSuggest, {
    AllOptions,
    AS_OPTIONS_SEARCH,
} from '../prescriptionPad/rightPanel/workspace/padV2/PadV2AutoSuggest';
import { randomString } from '../../store/utils';
import { medicalHistoryOptions } from './CustomiseSections';
import { DrugAllergy, MEDICAL_HISTORY_CATEGORY, MHItem } from '../../store/types/medicalHistory';
import { MEDICAL_HISTORY_CONTAINER } from '../prescriptionPad/rightPanel/workspace/MedicalHistoryContainer';

interface Props {
    setMedicalHistoryCommonItemsSectionData: (id: MEDICAL_HISTORY_CATEGORY, option: MHItem) => void;
    medicalHistoryCommonItems: ReadonlyArray<MHItem>;
    selectedSection: MEDICAL_HISTORY_CATEGORY;
    elidPrefixId: string;
    api?: (text?: string, qParams?: string) => Promise<MHItem[]>;
    isMedicalHistorySection?: boolean;
}

export class MedicalHealthConfigAutoSuggest extends PureComponent<Props> {
    static gElements: GLabVitalEntity[] | undefined;

    onSaveItems = (selectedSection: MEDICAL_HISTORY_CATEGORY, data: MHItem): void => {
        const { setMedicalHistoryCommonItemsSectionData } = this.props;
        const item = {
            id: data.id,
            name: data.name,
            status: data.status === undefined ? 'Active' : data.status,
        };
        if (selectedSection === MEDICAL_HISTORY_CATEGORY.DRUG_ALLERGY) {
            setMedicalHistoryCommonItemsSectionData(selectedSection, {
                ...item,
                generic_id: (data as DrugAllergy).generic_id,
                generic_name: (data as DrugAllergy).generic_name,
            });
        } else {
            setMedicalHistoryCommonItemsSectionData(selectedSection, item);
        }
    };

    getOptions = (
        setOptions: (options: AllOptions<MHItem>, inputValue?: string) => void,
        input?: string,
    ): void => {
        if (!input) {
            setOptions([], input);
            return;
        }

        if (this.props.api) {
            this.props
                .api(input)
                .then(async (response) => {
                    this.handleApiOptions(input, setOptions, response);
                })
                .catch(() => {
                    this.handleApiOptions(input, setOptions);
                });
        } else {
            this.handleApiOptions(input, setOptions);
        }
    };

    handleApiOptions = (
        input: string,
        setOptions: (options: AllOptions<MHItem>, inputValue?: string) => void,
        response?: MHItem[],
    ): void => {
        const { medicalHistoryCommonItems } = this.props;

        const allOptions: MHItem[] = [];

        response
            ?.filter((e) => !medicalHistoryCommonItems.find((t) => t.id === e.id))
            .forEach((i) => {
                if (!allOptions.find((s) => s.id === i.id)) {
                    allOptions.push(i);
                }
            });

        const isMatchFound = allOptions?.find((i) => i.name.toLowerCase() === input.toLowerCase());

        allOptions.splice(7);

        if (!isMatchFound && input) {
            allOptions.push({
                id: `${LOCAL_ID_PREFIX}${new Date().getTime()}-${randomString(4)}`,
                name: input,
            });
        }

        setOptions([{ label: AS_OPTIONS_SEARCH, options: allOptions }], input);
    };

    optionIcon = (<div>{medicalHistoryOptions[this.props.selectedSection].searchIcon()}</div>);
    elidValue = `${this.props.elidPrefixId}_${this.props.selectedSection.toUpperCase()}`;

    render(): ReactNode {
        const { medicalHistoryCommonItems, selectedSection, isMedicalHistorySection } = this.props;
        return (
            <PadV2AutoSuggest
                onSelect={(data) => this.onSaveItems(selectedSection, data)}
                optionIconText={this.optionIcon}
                optionIconBgClass={'circle-sy'}
                menuListClassName={'sy-dropdown'}
                optionWrapperClass={'sy-dropdown-item'}
                getOptions={this.getOptions}
                placeholder="Start typing a parameter..."
                elements={medicalHistoryCommonItems}
                targetContainer={isMedicalHistorySection ? MEDICAL_HISTORY_CONTAINER : undefined}
            />
        );
    }
}
